﻿/**
 * portal-app-context.manager
 * @namespace portal
 */

(function () {
	'use strict';

	/** add manager */
	angular.module('nha.portal').service('portal-app-context.manager', portalAppContextManager);

	/** setup inject */
	portalAppContextManager.$inject = ['$q', '$state', '$interval', 'ipCookie', 'userContextService', 'appContextFactory'];

	/** implement the manager */
	function portalAppContextManager($q, $state, $interval, ipCookie, userContextService, appContextFactory) {
		/** instantiate the context manager */
		var contextManager = new appContextFactory(null, [loadSchoolFromSelector]);

		/** private properties */
		var appContextModel = contextManager.getContext();

		/** public methods */
		contextManager.ensurePortalContext = ensurePortalContext;
		contextManager.resetContext = resetContext;
		contextManager.setBreadcrumbLabel = setBreadcrumbLabel;

		/** add load app context */
		function ensurePortalContext() {
			/** create a promise */
			var deferred = $q.defer();

			/** check for context */
			if (appContextModel.school === null || !appContextModel.roles) {
				/** run the ensure app context */
				contextManager.ensureAppContext().then(function(context) {
					/** set the current context */
					deferred.resolve(context);
				});
			} else {
				/** resolve with current context */
				deferred.resolve(appContextModel);
			}

			/** return the promise */
			return deferred.promise;
		}

		/** reset the context */
		function resetContext() {
			/** clear the context and reset */
			_.forIn(appContextModel, function(value, key) {
				appContextModel[key] = null;
			});

			/** reload the context */
			return ensurePortalContext();
		}

		/** set a state's breadcrumb label */
		function setBreadcrumbLabel(stateName, value) {
			/** get the state config  */
			var config = $state.get(stateName);
			if (config && config.ncyBreadcrumb) {
				if (config.ncyBreadcrumb.label !== undefined) config.ncyBreadcrumb.label = value;
				if (config.ncyBreadcrumbLabel !== undefined) config.ncyBreadcrumbLabel = value;
			}
		}

		/** return the context manager */
		return contextManager;

		/** private methods */

		/** load the school from the school selector */
		function loadSchoolFromSelector() {
			/** create the promise */
			var deferred = $q.defer();

			/** state param not set so look for the cookie */
			userContextService.ensureUserContext().then(function(context) {
				/** we need to wait for the school cookie to be set */
				var interval = $interval(function() {
					/** attempt to get the cookie */
					var defaultSchoolCookieName = 'nha.core.user-default-school.' + context['http://schemas.mynha.com/Savyint/UserID'];
					var defaultSchool = ipCookie(defaultSchoolCookieName) !== null ? ipCookie(defaultSchoolCookieName) : null;

					/** has school been set */
					if (defaultSchool && defaultSchool !== null) {
						/** cancel the interval */
						$interval.cancel(interval);
						interval = undefined;

						/** set the user roles */
						appContextModel.roles = context.role;

						/** set the app context school */
						appContextModel.school = defaultSchool;

						/** set the staff information */
						appContextModel.staffID = parseInt(context['http://schemas.mynha.com/SIS/Core/StaffID']);
						appContextModel.staffName = context.commonname;

						/** get the users schools */
						var usersSchools = userContextService.getUserContext()["http://schemas.mynha.com/ILM/SchoolID"];
						appContextModel.schoolIDs = (_.isArray(usersSchools) ? usersSchools : [usersSchools]);

						/** resolve the promise */
						deferred.resolve();
					}
				}, 100);
			});

			/** return the promise */
			return deferred.promise;
		}
	}
})();